import { useCallback } from 'react'

import emDash from '~/components/emdash'

import { useNumberFormatter } from './number'
import type { FormatterHook } from './types'
import { combineOptions } from './types'
import { useUnitsFormatter } from './units'

const defaultOptions = {
  longForm: false,
  sigFigs: 1,
  units: 'A',
  omitUnits: false,
  invalidStr: emDash
}

const exportOptions = { ...defaultOptions, omitUnits: true, invalidStr: '' }

// eslint-disable-next-line import/prefer-default-export
export const useCurrentFormatter: FormatterHook = () => {
  const formatNumber = useNumberFormatter()
  const formatUnits = useUnitsFormatter()

  return useCallback(
    (value, options) => {
      const {
        value: current,
        longForm,
        sigFigs,
        units,
        omitUnits,
        invalidStr
      } = combineOptions({
        value,
        options,
        defaults: defaultOptions,
        exports: exportOptions
      })

      if (units !== 'A') return invalidStr
      if (typeof current !== 'string' && typeof current !== 'number') return invalidStr

      // Coerce to number
      const currentNum = parseFloat(`${current}`)
      if (isNaN(currentNum)) return invalidStr

      const currentStr = formatNumber(currentNum, { maximumFractionDigits: sigFigs, export: options?.export })
      if (omitUnits) return currentStr

      const formattedUnits = formatUnits.current(longForm ? 'long' : 'short')
      return [currentStr, formattedUnits].join(' ')
    },
    [formatNumber, formatUnits]
  )
}
